import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import BusinessInfoSettings from "./infoSettings";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";


const BusinessWidgets = () => {
    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Business Update</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div className="settings-list-wrapper">
                        <div className="single-settings">
                            <h5 className="setting-title">Widgets</h5>
                            <div className="setting-content">
                                <div className="sng-content-repeater bs-wgt-wrapper">
                                    <div className="sng-content-widget">
                                        <div className="sng-wgt-left">
                                            <i className="ri-phone-line"></i>
                                            <span>Phone</span>
                                        </div>
                                        <a className="delete-widget">Delete</a>
                                    </div>
                                    <div className="sng-content-widget">
                                        <div className="sng-wgt-left">
                                            <i className="ri-mail-line"></i>
                                            <span>Email</span>
                                        </div>
                                        <a className="delete-widget">Delete</a>
                                    </div>
                                    <div className="sng-content-widget">
                                        <div className="sng-wgt-left">
                                            <i className="ri-map-pin-line"></i>
                                            <span>Address</span>
                                        </div>
                                        <a className="delete-widget">Delete</a>
                                    </div>
                                    <div className="add-bg-widget">
                                        <a> <i className="ri-add-circle-line"></i> Add new widget</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BusinessWidgets;
